import { SortOrder } from '../../../src/store/models/SearchModels'

export const SELECTED_VEHICLE_KEY = 'selected-vehicle'

export const AUTO_LIGHT_MEDIUM_TRUCK_ID = 111

export const LOAD_PER_REQUEST = 10
export const VEHICLE_SYSTEM = 'VEHICLE SYSTEM'

export const RETRY_SEARCH_LIMIT = 3

export enum ClearSAYT {
  YES,
  NO,
}

export enum FilterGroupName {
  LINES = 'Lines',
  STOCK = 'Stock',
  BRANDS = 'Brands',
  PART_TYPE = 'Part Type',
}

export enum LineTypes {
  PRIMARY = 'Primary',
  SECONDARY = 'Secondary',
  ALL_LINES = 'All Lines',
}

export enum StockOptions {
  ONLY_PRICED = 'Only Priced',
  ONLY_STOCKED = 'Only Stocked',
  SHOW_ALL = 'Show All',
}

export const DEFAULT_SORT_ORDER: SortOrder = [
  {
    property: 'Availability',
    label: 'Availability',
    dir: 'desc',
  },
  {
    property: 'Cost',
    label: 'Cost (Low-High)',
    dir: 'asc',
  },
]
